export default __webpack_public_path__ + "static/media/plan.18762bef.svg";